<div class="clock-widget text-warning text-center">
  <div class=" clock-date"><strong>{{ currentDateTime | date: dateFormatEnum.DATE_FORMAT_DISPLAY }}</strong></div>
  <div class="clock-time"><strong>{{ currentDateTime | date: dateFormatEnum.TIME_FORMAT_DISPLAY_WITHOUT_SECOND }}</strong></div>
</div>